'use client'
import { useEffect } from 'react'
import { analytics } from '../lib/firebase'

export function Analytics() {
    useEffect(() => {
        if (!analytics) return
        window.gtag?.('config',
          process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID!,
          {
            send_page_view: true,
            ...(process.env.NODE_ENV === 'development' && { debug_mode: true }),
          }
        )
    }, [])      
  return null
}
